export default __webpack_public_path__ + "static/media/cert-startup-cpttm.7bbde5f7.jpg";